import { useCallback } from "react";

import { WorksiteTableItem } from "../components/TableWorksites/TableWorksites";
import { useModalCreateWorksite } from "../modals/ModalCreateWorksite";
import { useModalDeleteWorksite } from "../modals/ModalDeleteWorksite";
import { useModalEditWorksite } from "../modals/ModalEditWorksite";

export const useWorksiteActions = ({
  isFirstWorksite
}: {
  /** No work site exists yet — the one being created becomes the primary. */
  isFirstWorksite: boolean;
}) => {
  const modalCreate = useModalCreateWorksite();
  const modalEdit = useModalEditWorksite();
  const modalDelete = useModalDeleteWorksite();

  const create = useCallback(() => {
    modalCreate.open({ isFirstWorksite });
  }, [modalCreate, isFirstWorksite]);

  const edit = useCallback(
    (item: WorksiteTableItem) => {
      modalEdit.open({ worksite: item.worksite });
    },
    [modalEdit]
  );

  const remove = useCallback(
    (item: WorksiteTableItem) => {
      modalDelete.open({
        worksite: item.worksite,
        engagementsCount: item.engagementNames.length
      });
    },
    [modalDelete]
  );

  return { create, edit, remove };
};
